<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style=" margin-bottom: 0;">
                  <div class="title_left">文献导出</div>
                  <div class="title_more2"><a href="">首页</a>>文献导出</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                    <div class="xbjj_con_title">
                      <span class="leftfloat">满足条件的记录共有<strong class="red">{{tabcontent.length}}</strong>条。</span>
                      <span class="rightfloat">
                          <el-button size="small" @click="success">{{buttonText}}</el-button>
                          <el-button size="small" @click="info">清空导出列表</el-button>
                       </span>
                      <div class="clearfix"></div>
                    </div>
					<div class="tab_con_left" style="margin-bottom: 10px;padding-top:10px" v-for="(view,index) in tabcontent" :key="index">
					  <div class="ml_title" >
						  <el-checkbox
						  v-model="view.Likes"
						  @change="checkchange(view)"
					      ></el-checkbox>
					    <a style="margin-left: 8px;" @click="todigest($event,view.ArticleID,view.Title,type)" v-html="view.Title"></a>
					    [{{view.Page_Num}}-{{view.Page_NumEnd}}]
					    <span
					      class="advance_date"
					      v-if="view.PreprintDate"
					    >[预出版日期：{{view.PreprintDate}}]</span>
					    <span class="advance_date" v-if="view.ScriptStatus">[阶段：{{view.ScriptStatus}}]</span>
					  </div>
					  <div class="ml_name">
					    <span>{{view.AuthorsList}}</span>
					    <!-- <el-popover placement="bottom-start" width="160">
					      <div class="well">
					        <div class="leftfloat Abstract_drop_title">摘要：</div>
					        <div class="leftfloat Abstract_drop_con" v-html="view.Abstract_Chinese"></div>
					        <div class="clearfix"></div>
					        <div class="leftfloat Abstract_drop_title" v-if="isEnzhaiy">Abstract：</div>
					        <div class="leftfloat Abstract_drop_con" v-if="isEnzhaiy" v-html="view.Abstract_English"></div>
					        <div class="clearfix"></div>
					      </div>
					      <el-button slot="reference" style=" border: none; background: none; padding: 0">
					        <img class="list_img" src="@/assets/images/abstract2.png" />摘要
					        <span class="rotator">
					          <img src="@/assets/images/down.png" />
					        </span>
					      </el-button>
					    </el-popover> -->
					    <!-- <a @click="todigest($event,view.ArticleID,view.Title,type)">
					      <img class="list_img" src="@/assets/images/liulan.png" />浏览
					      <font class="red">({{view.View_Times}})</font>次
					    </a>
					    <a @click="pdf(index,view.PDFFile_Size,view.ArticleID)">
					      <img class="list_img" src="@/assets/images/pdf.jpg" />
					      [PDF:{{parseFloat((view.PDFFile_Size / 1024).toFixed(2))}}KB]
					      <font
					        class="red"
					      >({{view.Read_Times}})</font>
					    </a>
					    <a>
					      <el-tooltip class="item" effect="dark" :content="view.OATip" placement="top">
					        <img src="@/assets/images/suo_open.png" class="lock" />
					      </el-tooltip>
					      <a v-if="view.HtmlFileUrl" :href="view.HtmlFileUrl">
					        <img src="@/assets/images/html.png" class="list_img" style="width:16px"/>[HTML](<span style="color:red">{{view.HtmlRead_Times}}</span>)
					      </a>
					    </a> -->
					  </div>
					 <div class="doi" v-if="view.DOI">
					   <a href>
					     <span class="red">DOI:</span>
					     {{view.DOI}}
					   </a>
					 </div>
					</div>
                </div>
              </div>
            </div>
          </el-col>
		  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top: 20px;">
		    <div class="grid-content bg-purple-light">
		      <div class="side_con">
				  <div class="user">
				    <div class="title_all" style=" margin-bottom: 12px;">
				      <div class="title_left">导出格式</div>
				      <div class="clearfix"></div>
				    </div>
				    <p style="display: inline-block;margin-right: 12px;"><el-radio @change="radioCilck(1)" v-model="radio" label="1">Notefirst</el-radio></p>
				    <p style="display: inline-block;margin-right: 12px;"><el-radio @change="radioCilck(2)" v-model="radio" label="2">Endnote</el-radio></p>
				    <p style="display: inline-block;"><el-radio @change="radioCilck(3)" v-model="radio" label="3">NoteExpress</el-radio></p>
				  </div>
				  <div>
				  	<PaperExportDetail :datail="datail" :name.sync="name"/>
				  </div>
			  </div>
			</div>
		  </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
	import PaperExportDetail from "@/components/parer_export/paper_export_detail" 
  export default {
    data() {
      return {
		buttonText:"取消选中",
        checked: true,
        radio:"1",
        label:"",
		num:1,
		datail:"",
		name:"",
        Ishtml:true,
        tabcontent:[],
		isEnzhaiy:"",
		type:0

      }
    },
    components: {PaperExportDetail},
	mounted() {
		this.Getlist()
	},
    methods: {
	  //获取列表
	  async Getlist(){
		   var src =new Date().getTime()
		   let IDS =''+this.$route.query.ids
		    let params = {
		      IDS
		    }
		    let Res = await this.$store.dispatch("_getWZDC",params)
			Res.data.Data.map(item=>{
				item.Likes = true
			})
		    this.tabcontent = Res.data.Data
			this.radioCilck(1)
	  },
      onSubmit() {
        console.log('submit!');
      },
	  success(){
		  //全选/全不选
		  if (this.buttonText == '取消选中') {
			  this.buttonText = '全部选中'
			  this.tabcontent.forEach(item=>{
				  item.Likes = false
			  })
			  this.name=''
		  } else if (this.buttonText == '全部选中') {
		    this.buttonText = '取消选中'
			this.tabcontent.forEach(item=>{
				item.Likes = true
			})
			
		  }
		  let num=0
		  if(this.radio){
			   num=parseInt(this.radio)  
		  }else{
			   num=1
			   this.radio='1'
		  }
		let type=1
		  this.radioCilck(num,type)
	  },
	  checkchange(view){
		  let num=0
		  if(this.radio){
			   num=parseInt(this.radio)  
		  }else{
			   num=1
			   this.radio='1'
		  }
		  let type=1
		  this.radioCilck(num,type)
	  },
	  radioCilck(num,type){
		//是否选择判定
		let IDS = "";
		this.tabcontent.map((val) => {
		  if (val.Likes) {
				IDS += val.ArticleID +","
			  }
		});
		
		if (IDS.length <= 0) {
			this.radio = false
		if(type){
			
			this.datail=""
		  return;
		}else{
alert("请选中文章");
return;
		}
		  
		}
		var arr = IDS.split("");
		arr.splice(arr.length-1,1);
		IDS = arr.join("");
		//选择模式
	  	this.checkeds = false
		this.num = num
		if(this.num==1){
			this.name = "NoteFirst"
		}else if(this.num==2){
			this.name = "EndNote"
		}else{
			this.name = "NoteExpress"
		}
		let params = {
		  ID: IDS,
		  Type: this.name
		}
		this.$store.dispatch("_getDCJK",params).then(res=>{
			if(res.data.IsSuccess){
				this.datail = res.data.Data
			}
		})
	  },
	  info(){
		//取消所有
	  	this.tabcontent = ""
	  },
	  _getXZCS(id) {
	    let params = {
	      Id: id
	    };
	    this.$store
	      .dispatch("_getXZCS", params)
	      .then(res => {})
	      .catch(err => {});
	  },
	  todigest(e, id, title,type) {
	    let path=''
	    if(type==0){
	      path="/digest?ArticleID=" + id
	    }else{
	      path='/ScriptPrePrintDetailed?ArticleID='+ id
	    }
	    this._getLLCS(id);
	    // this.getArticList();
	    e.preventDefault();
	    let routeUrl = this.$router.resolve({
	      path: path
	    });
	    window.open(routeUrl.href, "_blank");
	  },
	  _getLLCS(id) {
	      
	      let params = {
	        Id: id
	      }
	      this.$store.dispatch('_getLLCS',params)
	      .then(res => {
	      }).catch(err => {
	  
	      })
	    },
	  todig(e, id, title) {
	    this.getArticList();
	    this.NewList = this.Lista;
	    e.preventDefault();
	    // let routeUrl = this.$router.resolve({
	    //   path: "/digest?ArticleID=" + id
	    // });
	    // window.open(routeUrl.href, "_blank");
	  },
	  pdf(i, size, guid) {
	    if (size <= 0) {
	      alert("文件不存在");
	      return;
	    }
	    this.$store.dispatch("_getPDF", { Id: guid }).then(Result => {
        window.location.href =  Result.request.responseURL;
})
	  },
	  
	  downfil(num) {
	    let filename = "";
	    let Suffix = "";
	    if (num == 1) {
	      this.FileGUID = this.Periods.CoverGUID;
	    } else if (num == 2) {
	      this.FileGUID = this.Periods.BackCoverGUID;
	    } else {
	      this.FileGUID = this.Periods.TableConGUID;
	    }
	    var id = sessionStorage.getItem("id");
	    this.dz1 =
	      this.baseUrl +
	      "/api/Web/IssueDownLoad?Id=" +
	      id +
	      "&Type=" +
	      this.cotype;
	    this.OpenGUIDFile(this.FileGUID);
	  },
	  OpenGUIDFile(FileGUID) {
	    this.$store.dispatch('_OpenGUIDFile', {
          FileGUID:FileGUID
        }).then(res=>{
           if (res.data.IsSuccess) {
             this.$DownloadBase64File(res.data.Guid, 1);
           } else {
             this.$error(res.data.Message);
           }
         }).catch(error=>{
           console.log(error)
        })
	  }
    }
  }
</script>

<style scoped>
	.ml_name .list_img{
		width: 20px;
		height: 20px;
		margin-left:10px;
	}
</style>
